export default __webpack_public_path__ + "static/media/logo-dark.9cab1540.png";